<template>
 <div class="reserve">
  <div class="reserve-title">拼图设置</div>
  <div class="com-content">
    <van-form 
      :show-error-message="false" 
      validate-trigger="onSubmit" 
      validate-first
      ref="form"
    >
      <van-field
        required
        v-model="form.backgroundMusicName"
        label="背景音乐" 
        label-align="left" 
        input-align="right" 
        readonly 
        right-icon="arrow" 
        placeholder="请选择"
        @click="isMusic = true"
        :rules="[{ required: true, message: '请选择背景音乐' }]"
      />
      <div class="title">
        <span class="required">*</span>
        首页背景图
        <span class="title-tip">（建议尺寸750像素 X 1334像素）</span>
      </div>
      <van-field 
        name="uploader" 
        v-model="form.connectPicBackground"
        :rules="[{ required: true, message: '请上传背景图片' }]"
      >
        <template #input>
          <van-uploader 
            class="uploader" 
            :fileList="connectPicBackground" 
            :max-count="1" 
            preview-size="97" 
            result-type="file"
            :before-read="beforeImgUpload" 
            :after-read="uploadImgBack"
            @delete="(file) => deleteImg(file,'connectPicBackground')"
          />
        </template>
      </van-field>
      <van-field
        required
        v-model="form.timeLimit"
        type="digit"
        label="挑战时间(秒)" 
        label-align="left" 
        input-align="right" 
        placeholder="请输入"
        :rules="[{ required: true, message: '请输入挑战时间' }]"
        @blur="checkFeeValid('timeLimit')"
      />
      <div class="tips">在固定时间内，拼图成功即挑战成功（设置抽奖组件即可抽奖）</div>
      <div class="title"><span class="required">*</span>拼图难度</div>
      <van-field 
        name="radio" 
        input-align="center" 
        :rules="[{ required: true, message: '请选择拼图难度' }]"
      >
        <template #input>
          <van-radio-group class="box" icon-size="16px" v-model="form.challengeLevel">
            <div class="box1">
              <div class="box1-1">
                <div class="line-1"></div>
                <div class="line-2"></div>
                <div class="line-3"></div>
                <div class="line-4"></div>
              </div>
              <van-radio :name="2">2x2</van-radio>
            </div>
            <div class="box2">
              <div class="box2-1">
                <div class="line-1"></div>
                <div class="line-2"></div>
                <div class="line-3"></div>
                <div class="line-4"></div>
              </div>
              <van-radio :name="3">3x3</van-radio>
            </div>
            <div class="box3">
              <div class="box3-1">
                <div class="line-1"></div>
                <div class="line-2"></div>
                <div class="line-3"></div>
                <div class="line-4"></div>
                <div class="line-5"></div>
                <div class="line-6"></div>
              </div>
              <van-radio :name="4">4x4</van-radio>
            </div>
          </van-radio-group>
        </template>
      </van-field>
      <div class="title"><span class="required">*</span>拼图</div>
      <van-field 
        name="uploader" 
        v-model="form.connectPicBackground"
        :rules="[{ required: true, message: '请上传拼图' }]"
      >
        <template #input>
          <van-uploader 
            class="uploader" 
            :fileList="connectPic" 
            :max-count="1" 
            preview-size="97" 
            result-type="file"
            :before-read="beforeImgUpload" 
            :after-read="uploadImgConnect"
            @delete="(file) => deleteImg(file,'connectPic')"
          />
        </template>
      </van-field>
      
      <template v-if="JSON.parse(form.isLottery)">
        <div class="title bolder">拼图赠送抽奖机会</div>
        <van-field
          required
          v-model="lottery"
          label="抽奖机会赠送" 
          label-align="left" 
          input-align="right" 
          readonly 
          right-icon="arrow" 
          placeholder="请选择"
          :rules="[{ required: true, message: '请选择抽奖机会赠送' }]"
          @click="changeActionSheet(1)"
          
        />
        <van-field
          required
          v-model="form.sendLotteryTimes"
          input-align="right"
          label="每人赠送"
          placeholder="请输入"
          type="digit"
          :rules="[{ required: true, message: '请输入每人赠送' }]"
          @blur="checkFeeValid('sendLotteryTimes')"
        >
          <span slot="right-icon">次抽奖机会</span>
        </van-field>
      </template>
      <div class="title bolder">拼图机会设置</div>
      <van-field name="radio" input-align="right" label="拼图机会赠送">
        <template #input>
          <van-radio-group v-model="form.connectChanceSendType" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
            <van-radio name="everyDay">每日赠送</van-radio>
            <van-radio name="first">一次性赠送</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- <van-field
        v-if="isHasSignUp"
        v-model="form.signUpSendCount"
        type="digit"
        :maxlength="4"
        label="顾客成功报名活动,可获得"
        label-width="12em"
        input-align="center"
        placeholder="请输入"
        @blur="checkFeeValid('signUpSendCount')"
      >
        <span slot="right-icon">次拼图机会</span>
      </van-field> -->
      <van-field
        required
        v-model="form.sendConnectTimes"
        input-align="right"
        :label="label"
        placeholder="请输入"
        type="digit"
        :rules="[{ required: true, message: `请输入${label}` }]"
        @blur="checkFeeValid('sendConnectTimes')"
      >
        <span slot="right-icon">次拼图机会</span>
      </van-field>
      <div class="tips">当顾客拼图机会为零时进行赠送</div>
    </van-form>
  </div>
  <van-popup v-model="isMusic" position="bottom" get-container="body">
    <van-picker
      value-key="name"
      show-toolbar
      :columns="musicList"
      @confirm="musicConfirm"
      @cancel="onCancelMusic"
    />
  </van-popup>
  <van-popup v-model="isOverlay" :style="{width:'100%'}" :close-on-click-overlay="false" get-container="body">
    <div class="cropper">
      <h5-cropper ref="cropper" :option="option" @getFile="(e) => getFile(e,'connectPic')" @canceltailor="canceltailor"></h5-cropper>
    </div>
  </van-popup>
  <van-action-sheet v-model="isActionSheet" cancel-text="取消" :actions="actions" get-container="body" @select="onSelect" />
 </div>
</template>

<script>
import H5Cropper  from 'vue-cropper-h5'
import { round2Places } from '@/utils/utils'
export default {
  components: {H5Cropper},
  props: {
    value:  {
      type: Object,
      default() {
        return {}
      },
    },
    isHasSignUp: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('change', newVal)
      }
    },
    label() {
      return this.form.connectChanceSendType == 'everyDay' ? '每人每日赠送' : '本场活动赠送'
    },
    creationMode() {
      return this.$route.query.creationMode != 'new' ? true : false
    }
  },
  watch: {
    'form.connectPic': {
      handler(newVal) {
        if (newVal) {
          this.connectPic = [{url: newVal}]
        }else {
          this.connectPic = []
        }
      },
      deep: true,
      immediate: true,
    },
    'form.connectPicBackground': {
      handler(newVal) {
        if (newVal) {
          this.connectPicBackground = [{url: newVal}]
        }else {
          this.connectPicBackground = []
        }
      },
      deep: true,
      immediate: true,
    }
  },
  data() {
    return {
      isOverlay: false,
      type: '',
      isMusic: false,
      musicList: [],
      connectPicBackground: [],
      connectPic: [],
      isActionSheet: false,
      lottery: '',
      actions:[{name: '挑战成功只送一次',type: 'first'},{name: '每次挑战成功都送',type: 'everyTime'}],
      option: {
        ceilbutton: true,
        autoCropWidth: 600,
        autoCropHeight: 600,
      },
    }
  },
  methods: {
    // 获取音乐列表
    getBackgroundMusicList() {
      this.$api.question.getBackgroundMusicList().then(res => {
        if (res.success && res.data) {
          this.musicList = res.data
        }
      })
    },
    // 选择音乐
    musicConfirm(e) {
      const { name, url} = e
      this.form.backgroundMusicName = name
      this.form.backgroundMusic = url
      this.isMusic = false
    },
    onCancelMusic() {
      this.isMusic = false
    },
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }
      return true;
    },
    uploadImgBack(e) {
      this.getFile(e.file, 'connectPicBackground')
    },
    uploadImgConnect(e) {
      this.isOverlay = true
      this.$nextTick(()=> {
        this.$refs.cropper.loadFile(e.file)
      })
    },
    getFile(file,field) {
      this.isOverlay = false
      const currentFile = {
        url: '',
        status:'uploading',
        message: '上传中...'
      }
      this[field].push(currentFile)
      this.$api.common.uploadImg(file)
        .then(({data}) => {
          if (data && data[0]) {
            const fileUrl = data[0].fileUrl;
            this.form[field] = fileUrl
          }
        })
        .catch(err => {
          const currentIndex = this[field].indexOf(currentFile);
          if (currentIndex > -1) {
            this[field].splice(currentIndex, 1);
            this.form[field] = ''
          }
      });
    },
    canceltailor() {
      this.isOverlay = false
    },
    deleteImg(e,type) {
      this.form[type] = ''
    },
    changeActionSheet() {
      this.isActionSheet = true
    },
    onSelect(e) {
      const { name, type} = e
      this.lottery = name
      this.form.lotteryChanceType = type
      this.isActionSheet = false
    },
    checkFeeValid(fieldName) {
      let value = this.form[fieldName]
      if (fieldName == 'sendConnectTimes') {
        if (value == 0) {
          value = 1
        }
      }
      this.form[fieldName] = round2Places(value)
    },
    submit() {
      return new Promise((resolve,reject) => {
        this.$refs.form.validate()
          .then(res => {
            resolve(true)
          })
          .catch(err => {
            this.$toast(err[0].message);
            reject(false)
          })
      })
    },
    init() {
      const { lotteryChanceType } = this.form
      if (lotteryChanceType) {
        this.lottery = lotteryChanceType == 'first' ? '挑战成功只送一次' : '每次挑战成功都送'
      }
      this.getBackgroundMusicList()
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="stylus" scoped>
.reserve {
  margin: 15px 0;
  .reserve-title {
    padding: 15px 0 0 15px;
    font-size: 14px;
    font-weight: bold;
    color: #303133;
  }
  .com-content {
    margin 10px 15px
    padding 0 4px
    background-color: #fff
    border-radius: 8px;
    .title {
      position: relative;
      font-size: 14px;
      color: #646566;
      padding: 7px 16px;
      .required {
        position: absolute;
        color: #ee0a24;
        left: 8px;
      }
      .title-tip {
        font-size 12px
        color #999
      }
    }
    .bolder {
      color: #303133;
      font-weight: bolder;
    }
    .uploader {
      padding: 0px 16px;

    }
    .tips {
      background: #fff;
      padding: 10px 16px;
      font-size: 10px;
      color: #bbb;
    }
    .box {
      display: flex;
      justify-content: space-around;
      padding: 6px 0;
      width: 90%;
      .box1 {
        display: flex;
        flex-direction: column;
        align-items: center;
        .box1-1 {
          position: relative;
          width: 60px;
          height: 60px;
          border: 1px solid #ccc;
          margin-bottom: 10px;
          .line-1 {
            position: absolute;
            left: 50%;
            height: 100%;
            width: 1px;
            background: #ccc;
          }
           .line-2 {
            position: absolute;
            top: 50%;
            height: 1px;
            width: 100%;
            background: #ccc;
          }
        }
      }
      .box2 {
        display: flex;
        flex-direction: column;
        align-items: center;
        .box2-1 {
          position: relative;
          width: 60px;
          height: 60px;
          border: 1px solid #ccc;
          margin-bottom: 10px;
          .line-1 {
            position: absolute;
            left: 33.33%;
            height: 100%;
            width: 1px;
            background: #ccc;
          }
          .line-2 {
            position: absolute;
            left: 66.66%;
            height: 100%;
            width: 1px;
            background: #ccc;
          }
           .line-3 {
            position: absolute;
            top: 33.33%;
            height: 1px;
            width: 100%;
            background: #ccc;
          }
          .line-4 {
            position: absolute;
            top: 66.66%;
            height: 1px;
            width: 100%;
            background: #ccc;
          }
        }
      }
      .box3 {
        display: flex;
        flex-direction: column;
        align-items: center;
        .box3-1 {
          position: relative;
          width: 60px;
          height: 60px;
          border: 1px solid #ccc;
          margin-bottom: 10px;
          .line-1 {
            position: absolute;
            left: 25%;
            height: 100%;
            width: 1px;
            background: #ccc;
          }
          .line-2 {
            position: absolute;
            left: 50%;
            height: 100%;
            width: 1px;
            background: #ccc;
          }
          .line-3 {
            position: absolute;
            left: 75%;
            height: 100%;
            width: 1px;
            background: #ccc;
          }
           .line-4 {
            position: absolute;
            top: 25%;
            height: 1px;
            width: 100%;
            background: #ccc;
          }
          .line-5 {
            position: absolute;
            top: 50%;
            height: 1px;
            width: 100%;
            background: #ccc;
          }
          .line-6 {
            position: absolute;
            top: 75%;
            height: 1px;
            width: 100%;
            background: #ccc;
          }
        }
      
      }
      
    }
  }
}
.cropper {
  height: 100vh;
}
</style>